import posthog from 'posthog-js';
export { sanitizeExceptionProperties } from './errorPrivacy';

export function captureUiError(
  error: Error,
  operation: 'auth.recovery.render' | 'billing.render' | 'http.request',
  details: {
    status?: number;
    request_id?: string | null;
    stage?: string;
  } = {},
): void {
  if (process.env.REACT_APP_POSTHOG_ERROR_TRACKING_ENABLED !== 'true') return;
  try {
    // Existing before_send owns final scrubbing for manual and automatic errors.
    posthog.captureException(error, { operation, ...details });
  } catch {
    // Reporting must not interfere with the existing recovery UI.
  }
}
